export function base64ToArrayBuffer(base64) {
  var binaryString = atob(base64);
  var len = binaryString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export function checkBase64Type(base64String) {
  // console.log("getFileType");
  try {
    // Decode the Base64 string
    var decodedData = base64ToArrayBuffer(base64String);
  } catch (e) {
    return false;
  }

  // Define common file signatures (magic numbers) for images and other files
  var magicNumbers = {
    FFD8FF: "image", // JPEG, JPG
    "89504E470D0A1A0A": "image", // PNG
    47494638: "image", // GIF
    "424D": "image", // BMP
    25504446: "document", // PDF
    D0CF11E0: "document", // DOC, XLS, PPT (all use the same magic number)
    "504B0304": "document", // DOCX, XLSX, PPTX (all use the same magic number)
    // Add more file signatures if needed
  };

  // Convert the beginning of the decoded data to a hex string
  var hexString = Array.from(decodedData)
    .slice(0, 8)
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase();

  // Check the beginning of the decoded data against known magic numbers
  for (var magic in magicNumbers) {
    if (hexString.startsWith(magic)) {
      return magicNumbers[magic];
    }
  }

  return false;
}
